import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  EncouragingIcon,
  PatientIcon,
  FriendlyIcon,
  FocusedIcon,
  RightLongArrow,
  LeftLongArrow,
} from "../../constant/imagePath";
import classes from "./whatOurStudentSay.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Row } from "react-bootstrap";
import Carousel, { consts } from "react-elastic-carousel";
import { ReactSVG } from "react-svg";

export const WhatOurStudentSay = ({ data, showArrows, headerStyle }) => {
  const [renderArray, setRenderArray] = useState(data);
  const ref = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  // const HandleClick = (isRight) => {
  //     const element = renderArray[isRight? renderArray.length-1 : 0 ];
  //     const newArray = renderArray.slice();
  //     newArray.splice(isRight? renderArray.length-1 : 0, 1);
  //     newArray.splice(isRight? 0:renderArray.length-1, 0, element);
  //   setRenderArray(newArray);
  // };

  const myArrow = ({ type, onClick, isEdge }) => {
    const pointer = type === consts.PREV ? LeftLongArrow : RightLongArrow;
    return (
      <button
        onClick={onClick}
        disabled={isEdge}
        className={type === consts.PREV ? classes.leftBtn : classes.rightBtn}
      >
        <img src={pointer} />
      </button>
    );
  };

  return (
    <>
      <style jsx>{`
        .rec-slider-container {
          margin: 0px;
        }
        .${classes.leftBtn} {
          right: 68px;
        }
      `}</style>
      <div className={`${[classes.whatOurStudentsSay].join(" ")}`} >
        <div className={classes.header}>
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
              ...headerStyle
            }}
          >
            What our students say
          </h4>
          {showArrows && <div className={`d-flex `}>
            <button
              onClick={() => ref.current.slidePrev()}
              className={classes.leftBtn}
              disabled={currentIndex == 0 && true}
            >
              <img src={LeftLongArrow} />
            </button>
            <button
              onClick={() => ref.current.slideNext()}
              className={classes.rightBtn}
              disabled={currentIndex == data?.length - 2 && true}

            >
              <img src={RightLongArrow} />
            </button>
          </div>}

        </div>

        <div className={`${[classes.cardsBox].join(" ")}`}>
          <Carousel

            itemsToScroll={1}
            pagination={false}
            enableAutoPlay={false}
            itemPadding={[0]}
            ref={ref}
            showArrows={false}
            onNextEnd={(e) => setCurrentIndex(e.index)}
            onNextStart={(e) => setCurrentIndex(e.index)}
            breakPoints={
              [{ width: 200, itemsToShow: 2 }, { width: 450, itemsToShow: 4 },]
            }

          >
            {data?.map((item) => {
              return (
                <div
                  className={`${[classes.card].join(" ")}`}
                  style={{
                    border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                >
                  {/* Icon */}
                  <ReactSVG
                    src={item?.icon}
                    beforeInjection={(svg) => {
                      svg.classList.add(`${[classes.icon].join(" ")}`);
                    }}
                  />
                  {/* Text Box */}
                  <div className={`${[classes.cardTextBox].join(" ")}`}>
                    <p
                      className={`${[classes.title].join(" ")}`}
                      style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                    >
                      {item?.title}
                    </p>
                    <p
                      className={`${[classes.counts].join(" ")}`}
                      style={{ backgroundColor: Colors.mainShadeOfSolitude }}
                    >
                      {item?.value}
                    </p>
                  </div>
                </div>
              );
            })}
          </Carousel>
          {/* Card */}
          {/* {renderArray?.map((item) => {
          return (
            <div
              className={`col-md-4 ${[classes.card].join(" ")}`}
              style={{
                border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
            >
              <div className={`${[classes.icon].join(" ")}`}>
                <img src={item?.icon} />
              </div>
              <div className={`${[classes.cardTextBox].join(" ")}`}>
                <p
                  className={`${[classes.title].join(" ")}`}
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                >
                  {item?.title}
                </p>
                <p
                  className={`${[classes.counts].join(" ")}`}
                  style={{ backgroundColor: Colors.mainShadeOfSolitude }}
                >
                  {item?.value}
                </p>
              </div>
            </div>
          );
        })} */}
        </div>
      </div>
    </>
  );
};

WhatOurStudentSay.propTypes = {
  data: PropTypes.array,
  showArrows: PropTypes.bool,
};

WhatOurStudentSay.defaultProps = {
  data: [
    { icon: EncouragingIcon, title: "Encouraging", value: 10 },
    { icon: FriendlyIcon, title: "Friendly", value: 9 },
    { icon: FocusedIcon, title: "Focused", value: 5 },
    { icon: PatientIcon, title: "Patient", value: 2 },
    { icon: FriendlyIcon, title: "Friendly-New", value: 5 },
  ],
  showArrows: true
};
